document.addEventListener('DOMContentLoaded', function() {
    const zaehlerElemente = document.querySelectorAll('.zaehler');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                startZaehlen(entry.target);
                observer.unobserve(entry.target);
            }
        });
    });

    zaehlerElemente.forEach(element => {
        observer.observe(element);
    });

    function startZaehlen(element) {
        const zielWert = parseInt(element.textContent, 10);
        let aktuellerWert = 0;
        const gesamtDauer = 3000; // 3 Sekunden
        const intervallDauer = gesamtDauer / zielWert;

        const interval = setInterval(() => {
            aktuellerWert++;
            element.textContent = aktuellerWert;

            if (aktuellerWert >= zielWert) {
                clearInterval(interval);
            }
        }, intervallDauer);
    }
});
